import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { FooterComponent } from "../../components/common/footer/footer";
import { NavigationComponent } from "../../components/common/navigation/navigation";

@Component({
  selector: "page-disclaimer",
  templateUrl: "disclaimer.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, NavigationComponent, TranslatePipe],
})
export class DisclaimerPage {}
